// Reviews panel (sections/sivana-home-proof.liquid): tapping the star rating in the proof strip opens a
// panel of the newest 5-star reviews. Close with the X, a tap on the dimmed page, or Escape.
if (!window.sivanaReviewsPanel) {
  window.sivanaReviewsPanel = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-sivana-reviews-open]');
    if (opener) {
      const panel = document.getElementById(opener.dataset.sivanaReviewsOpen);
      if (panel && !panel.open) {
        event.preventDefault();
        panel.showModal();
      }
      return;
    }
    const panel = event.target.closest('[data-sivana-reviews-drawer]');
    if (!panel) return;
    if (event.target === panel || event.target.closest('[data-sivana-reviews-close]')) panel.close();
  });
}
